import { DEVICE_PARAMETERS_KEYS } from './mapDeviceParameters';

const missingDeviceCsvColumns = CsvRow => {
  const validKeys = Object.keys(DEVICE_PARAMETERS_KEYS);
  const rowKeys = Object.keys(CsvRow).map(key => key.trim().toLowerCase());
  return validKeys.filter(key => rowKeys.indexOf(key) === -1)
}

export default missingDeviceCsvColumns;
